// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-user:before {
  content: '\\e93f';
}
.icon-activity:before {
  content: '\\e940';
}
.icon-arrow-down-2:before {
  content: '\\e941';
}
.icon-arrow-down-circle:before {
  content: '\\e942';
}
.icon-arrow-down:before {
  content: '\\e943';
}
.icon-arrow-left-2:before {
  content: '\\e944';
}
.icon-arrow-left-circle:before {
  content: '\\e945';
}
.icon-arrow-left:before {
  content: '\\e946';
}
.icon-arrow-right-2:before {
  content: '\\e947';
}
.icon-arrow-right-circle:before {
  content: '\\e948';
}
.icon-arrow-right:before {
  content: '\\e949';
}
.icon-arrow-up-2:before {
  content: '\\e94a';
}
.icon-arrow-up-circle:before {
  content: '\\e94b';
}
.icon-arrow-up:before {
  content: '\\e94c';
}
.icon-billing-date:before {
  content: '\\e94d';
}
.icon-birthday:before {
  content: '\\e94e';
}
.icon-bookmark:before {
  content: '\\e94f';
}
.icon-calendar:before {
  content: '\\e950';
}
.icon-category:before {
  content: '\\e951';
}
.icon-chat:before {
  content: '\\e952';
}
.icon-checkbox-empty:before {
  content: '\\e953';
}
.icon-close-2:before {
  content: '\\e954';
}
.icon-close:before {
  content: '\\e955';
}
.icon-contact-us:before {
  content: '\\e956';
}
.icon-copy-link:before {
  content: '\\e957';
}
.icon-correct-round-empty:before {
  content: '\\e958';
}
.icon-correct-round:before {
  content: '\\e959';
}
.icon-countdown:before {
  content: '\\e95a';
}
.icon-danger-circle:before {
  content: '\\e95b';
}
.icon-delete:before {
  content: '\\e95c';
}
.icon-device-list:before {
  content: '\\e95d';
}
.icon-document:before {
  content: '\\e95e';
}
.icon-download-2:before {
  content: '\\e95f';
}
.icon-download:before {
  content: '\\e960';
}
.icon-edit:before {
  content: '\\e961';
}
.icon-email:before {
  content: '\\e962';
}
.icon-facebook:before {
  content: '\\e963';
}
.icon-filter-3:before {
  content: '\\e964';
}
.icon-filter:before {
  content: '\\e965';
}
.icon-gender:before {
  content: '\\e966';
}
.icon-heart:before {
  content: '\\e967';
}
.icon-hide:before {
  content: '\\e968';
}
.icon-home:before {
  content: '\\e969';
}
.icon-id:before {
  content: '\\e96a';
}
.icon-image-3:before {
  content: '\\e96b';
}
.icon-key:before {
  content: '\\e96c';
}
.icon-location:before {
  content: '\\e96d';
}
.icon-lock:before {
  content: '\\e96e';
}
.icon-mandates:before {
  content: '\\e96f';
}
.icon-message:before {
  content: '\\e970';
}
.icon-mobile-number:before {
  content: '\\e971';
}
.icon-name:before {
  content: '\\e972';
}
.icon-new-user-revised:before {
  content: '\\e973';
}
.icon-notice:before {
  content: '\\e974';
}
.icon-notification:before {
  content: '\\e975';
}
.icon-passport:before {
  content: '\\e976';
}
.icon-pending:before {
  content: '\\e977';
}
.icon-plus:before {
  content: '\\e978';
}
.icon-price-tag:before {
  content: '\\e979';
}
.icon-profile:before {
  content: '\\e97a';
}
.icon-protect:before {
  content: '\\e97b';
}
.icon-question:before {
  content: '\\e97c';
}
.icon-refresh:before {
  content: '\\e97d';
}
.icon-renew-date:before {
  content: '\\e97e';
}
.icon-safe:before {
  content: '\\e97f';
}
.icon-search:before {
  content: '\\e980';
}
.icon-setting:before {
  content: '\\e981';
}
.icon-shield-done:before {
  content: '\\e982';
}
.icon-shield-fail:before {
  content: '\\e983';
}
.icon-show:before {
  content: '\\e984';
}
.icon-star:before {
  content: '\\e985';
}
.icon-subscription-plan-2:before {
  content: '\\e986';
}
.icon-subscription-plan:before {
  content: '\\e987';
}
.icon-tick-square:before {
  content: '\\e988';
}
.icon-transfer:before {
  content: '\\e989';
}
.icon-unlock:before {
  content: '\\e98a';
}
.icon-upload:before {
  content: '\\e98b';
}
.icon-wallet-unfilled:before {
  content: '\\e98c';
}
.icon-warning:before {
  content: '\\e98d';
}
.icon-user-filled:before {
  content: '\\e900';
}
.icon-activity-filled:before {
  content: '\\e901';
}
.icon-american-express-filled:before {
  content: '\\e902';
}
.icon-arrow-down-3-filled:before {
  content: '\\e903';
}
.icon-arrow-down-circle-filled:before {
  content: '\\e904';
}
.icon-arrow-left-3-filled:before {
  content: '\\e905';
}
.icon-arrow-left-circle-filled:before {
  content: '\\e906';
}
.icon-arrow-right-3-filled:before {
  content: '\\e907';
}
.icon-arrow-right-circle-filled:before {
  content: '\\e908';
}
.icon-arrow-up-3-filled:before {
  content: '\\e909';
}
.icon-arrow-up-circle-filled:before {
  content: '\\e90a';
}
.icon-bookmark-filled:before {
  content: '\\e90b';
}
.icon-calendar-filled:before {
  content: '\\e90c';
}
.icon-category-filled:before {
  content: '\\e90d';
}
.icon-chat-filled:before {
  content: '\\e90e';
}
.icon-close-filled:before {
  content: '\\e90f';
}
.icon-contact-us-filled:before {
  content: '\\e910';
}
.icon-correct-round-filled:before {
  content: '\\e911';
}
.icon-csv-filled:before {
  content: '\\e912';
}
.icon-delete-filled:before {
  content: '\\e913';
}
.icon-device-list-filled:before {
  content: '\\e914';
}
.icon-discount-box-filled:before {
  content: '\\e915';
}
.icon-document-filled:before {
  content: '\\e916';
}
.icon-dot-filled:before {
  content: '\\e917';
}
.icon-down-filled:before {
  content: '\\e918';
}
.icon-download-filled:before {
  content: '\\e919';
}
.icon-edit-filled:before {
  content: '\\e91a';
}
.icon-excel-sheet-filled:before {
  content: '\\e91b';
}
.icon-facebook-filled:before {
  content: '\\e91c';
}
.icon-filter-2-filled:before {
  content: '\\e91d';
}
.icon-filter-filled:before {
  content: '\\e91e';
}
.icon-heart-filled:before {
  content: '\\e91f';
}
.icon-hide-filled:before {
  content: '\\e920';
}
.icon-home-filled:before {
  content: '\\e921';
}
.icon-image-filled:before {
  content: '\\e922';
}
.icon-info-circle-filled:before {
  content: '\\e923';
}
.icon-location-filled:before {
  content: '\\e924';
}
.icon-lock-filled:before {
  content: '\\e925';
}
.icon-mandates-filled:before {
  content: '\\e926';
}
.icon-message-filled:before {
  content: '\\e927';
}
.icon-notification-filled:before {
  content: '\\e928';
}
.icon-pdf-filled:before {
  content: '\\e929';
}
.icon-pending-filled:before {
  content: '\\e92a';
}
.icon-profile-filled:before {
  content: '\\e92b';
}
.icon-protected-filled:before {
  content: '\\e92c';
}
.icon-question-filled:before {
  content: '\\e92d';
}
.icon-refresh-filled:before {
  content: '\\e92e';
}
.icon-search-filled:before {
  content: '\\e92f';
}
.icon-setting-filled:before {
  content: '\\e930';
}
.icon-shield-done-filled:before {
  content: '\\e931';
}
.icon-shield-fail-filled:before {
  content: '\\e932';
}
.icon-show-filled:before {
  content: '\\e933';
}
.icon-star-filled:before {
  content: '\\e934';
}
.icon-subscribe-plan-filled:before {
  content: '\\e935';
}
.icon-tick-square-filled:before {
  content: '\\e936';
}
.icon-transfer-filled:before {
  content: '\\e937';
}
.icon-twitter-filled:before {
  content: '\\e938';
}
.icon-unlock-filled:before {
  content: '\\e939';
}
.icon-up-filled:before {
  content: '\\e93a';
}
.icon-upload-filled:before {
  content: '\\e93b';
}
.icon-user-key-filled:before {
  content: '\\e93c';
}
.icon-user-locked-filled:before {
  content: '\\e93d';
}
.icon-wallet-filled-filled:before {
  content: '\\e93e';
}
`, "",{"version":3,"sources":["webpack://./src/styles/icons.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".icon-user:before {\n  content: '\\e93f';\n}\n.icon-activity:before {\n  content: '\\e940';\n}\n.icon-arrow-down-2:before {\n  content: '\\e941';\n}\n.icon-arrow-down-circle:before {\n  content: '\\e942';\n}\n.icon-arrow-down:before {\n  content: '\\e943';\n}\n.icon-arrow-left-2:before {\n  content: '\\e944';\n}\n.icon-arrow-left-circle:before {\n  content: '\\e945';\n}\n.icon-arrow-left:before {\n  content: '\\e946';\n}\n.icon-arrow-right-2:before {\n  content: '\\e947';\n}\n.icon-arrow-right-circle:before {\n  content: '\\e948';\n}\n.icon-arrow-right:before {\n  content: '\\e949';\n}\n.icon-arrow-up-2:before {\n  content: '\\e94a';\n}\n.icon-arrow-up-circle:before {\n  content: '\\e94b';\n}\n.icon-arrow-up:before {\n  content: '\\e94c';\n}\n.icon-billing-date:before {\n  content: '\\e94d';\n}\n.icon-birthday:before {\n  content: '\\e94e';\n}\n.icon-bookmark:before {\n  content: '\\e94f';\n}\n.icon-calendar:before {\n  content: '\\e950';\n}\n.icon-category:before {\n  content: '\\e951';\n}\n.icon-chat:before {\n  content: '\\e952';\n}\n.icon-checkbox-empty:before {\n  content: '\\e953';\n}\n.icon-close-2:before {\n  content: '\\e954';\n}\n.icon-close:before {\n  content: '\\e955';\n}\n.icon-contact-us:before {\n  content: '\\e956';\n}\n.icon-copy-link:before {\n  content: '\\e957';\n}\n.icon-correct-round-empty:before {\n  content: '\\e958';\n}\n.icon-correct-round:before {\n  content: '\\e959';\n}\n.icon-countdown:before {\n  content: '\\e95a';\n}\n.icon-danger-circle:before {\n  content: '\\e95b';\n}\n.icon-delete:before {\n  content: '\\e95c';\n}\n.icon-device-list:before {\n  content: '\\e95d';\n}\n.icon-document:before {\n  content: '\\e95e';\n}\n.icon-download-2:before {\n  content: '\\e95f';\n}\n.icon-download:before {\n  content: '\\e960';\n}\n.icon-edit:before {\n  content: '\\e961';\n}\n.icon-email:before {\n  content: '\\e962';\n}\n.icon-facebook:before {\n  content: '\\e963';\n}\n.icon-filter-3:before {\n  content: '\\e964';\n}\n.icon-filter:before {\n  content: '\\e965';\n}\n.icon-gender:before {\n  content: '\\e966';\n}\n.icon-heart:before {\n  content: '\\e967';\n}\n.icon-hide:before {\n  content: '\\e968';\n}\n.icon-home:before {\n  content: '\\e969';\n}\n.icon-id:before {\n  content: '\\e96a';\n}\n.icon-image-3:before {\n  content: '\\e96b';\n}\n.icon-key:before {\n  content: '\\e96c';\n}\n.icon-location:before {\n  content: '\\e96d';\n}\n.icon-lock:before {\n  content: '\\e96e';\n}\n.icon-mandates:before {\n  content: '\\e96f';\n}\n.icon-message:before {\n  content: '\\e970';\n}\n.icon-mobile-number:before {\n  content: '\\e971';\n}\n.icon-name:before {\n  content: '\\e972';\n}\n.icon-new-user-revised:before {\n  content: '\\e973';\n}\n.icon-notice:before {\n  content: '\\e974';\n}\n.icon-notification:before {\n  content: '\\e975';\n}\n.icon-passport:before {\n  content: '\\e976';\n}\n.icon-pending:before {\n  content: '\\e977';\n}\n.icon-plus:before {\n  content: '\\e978';\n}\n.icon-price-tag:before {\n  content: '\\e979';\n}\n.icon-profile:before {\n  content: '\\e97a';\n}\n.icon-protect:before {\n  content: '\\e97b';\n}\n.icon-question:before {\n  content: '\\e97c';\n}\n.icon-refresh:before {\n  content: '\\e97d';\n}\n.icon-renew-date:before {\n  content: '\\e97e';\n}\n.icon-safe:before {\n  content: '\\e97f';\n}\n.icon-search:before {\n  content: '\\e980';\n}\n.icon-setting:before {\n  content: '\\e981';\n}\n.icon-shield-done:before {\n  content: '\\e982';\n}\n.icon-shield-fail:before {\n  content: '\\e983';\n}\n.icon-show:before {\n  content: '\\e984';\n}\n.icon-star:before {\n  content: '\\e985';\n}\n.icon-subscription-plan-2:before {\n  content: '\\e986';\n}\n.icon-subscription-plan:before {\n  content: '\\e987';\n}\n.icon-tick-square:before {\n  content: '\\e988';\n}\n.icon-transfer:before {\n  content: '\\e989';\n}\n.icon-unlock:before {\n  content: '\\e98a';\n}\n.icon-upload:before {\n  content: '\\e98b';\n}\n.icon-wallet-unfilled:before {\n  content: '\\e98c';\n}\n.icon-warning:before {\n  content: '\\e98d';\n}\n.icon-user-filled:before {\n  content: '\\e900';\n}\n.icon-activity-filled:before {\n  content: '\\e901';\n}\n.icon-american-express-filled:before {\n  content: '\\e902';\n}\n.icon-arrow-down-3-filled:before {\n  content: '\\e903';\n}\n.icon-arrow-down-circle-filled:before {\n  content: '\\e904';\n}\n.icon-arrow-left-3-filled:before {\n  content: '\\e905';\n}\n.icon-arrow-left-circle-filled:before {\n  content: '\\e906';\n}\n.icon-arrow-right-3-filled:before {\n  content: '\\e907';\n}\n.icon-arrow-right-circle-filled:before {\n  content: '\\e908';\n}\n.icon-arrow-up-3-filled:before {\n  content: '\\e909';\n}\n.icon-arrow-up-circle-filled:before {\n  content: '\\e90a';\n}\n.icon-bookmark-filled:before {\n  content: '\\e90b';\n}\n.icon-calendar-filled:before {\n  content: '\\e90c';\n}\n.icon-category-filled:before {\n  content: '\\e90d';\n}\n.icon-chat-filled:before {\n  content: '\\e90e';\n}\n.icon-close-filled:before {\n  content: '\\e90f';\n}\n.icon-contact-us-filled:before {\n  content: '\\e910';\n}\n.icon-correct-round-filled:before {\n  content: '\\e911';\n}\n.icon-csv-filled:before {\n  content: '\\e912';\n}\n.icon-delete-filled:before {\n  content: '\\e913';\n}\n.icon-device-list-filled:before {\n  content: '\\e914';\n}\n.icon-discount-box-filled:before {\n  content: '\\e915';\n}\n.icon-document-filled:before {\n  content: '\\e916';\n}\n.icon-dot-filled:before {\n  content: '\\e917';\n}\n.icon-down-filled:before {\n  content: '\\e918';\n}\n.icon-download-filled:before {\n  content: '\\e919';\n}\n.icon-edit-filled:before {\n  content: '\\e91a';\n}\n.icon-excel-sheet-filled:before {\n  content: '\\e91b';\n}\n.icon-facebook-filled:before {\n  content: '\\e91c';\n}\n.icon-filter-2-filled:before {\n  content: '\\e91d';\n}\n.icon-filter-filled:before {\n  content: '\\e91e';\n}\n.icon-heart-filled:before {\n  content: '\\e91f';\n}\n.icon-hide-filled:before {\n  content: '\\e920';\n}\n.icon-home-filled:before {\n  content: '\\e921';\n}\n.icon-image-filled:before {\n  content: '\\e922';\n}\n.icon-info-circle-filled:before {\n  content: '\\e923';\n}\n.icon-location-filled:before {\n  content: '\\e924';\n}\n.icon-lock-filled:before {\n  content: '\\e925';\n}\n.icon-mandates-filled:before {\n  content: '\\e926';\n}\n.icon-message-filled:before {\n  content: '\\e927';\n}\n.icon-notification-filled:before {\n  content: '\\e928';\n}\n.icon-pdf-filled:before {\n  content: '\\e929';\n}\n.icon-pending-filled:before {\n  content: '\\e92a';\n}\n.icon-profile-filled:before {\n  content: '\\e92b';\n}\n.icon-protected-filled:before {\n  content: '\\e92c';\n}\n.icon-question-filled:before {\n  content: '\\e92d';\n}\n.icon-refresh-filled:before {\n  content: '\\e92e';\n}\n.icon-search-filled:before {\n  content: '\\e92f';\n}\n.icon-setting-filled:before {\n  content: '\\e930';\n}\n.icon-shield-done-filled:before {\n  content: '\\e931';\n}\n.icon-shield-fail-filled:before {\n  content: '\\e932';\n}\n.icon-show-filled:before {\n  content: '\\e933';\n}\n.icon-star-filled:before {\n  content: '\\e934';\n}\n.icon-subscribe-plan-filled:before {\n  content: '\\e935';\n}\n.icon-tick-square-filled:before {\n  content: '\\e936';\n}\n.icon-transfer-filled:before {\n  content: '\\e937';\n}\n.icon-twitter-filled:before {\n  content: '\\e938';\n}\n.icon-unlock-filled:before {\n  content: '\\e939';\n}\n.icon-up-filled:before {\n  content: '\\e93a';\n}\n.icon-upload-filled:before {\n  content: '\\e93b';\n}\n.icon-user-key-filled:before {\n  content: '\\e93c';\n}\n.icon-user-locked-filled:before {\n  content: '\\e93d';\n}\n.icon-wallet-filled-filled:before {\n  content: '\\e93e';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
